import { __makeTemplateObject } from '../../../_virtual/_tslib.js';
import styled from 'styled-components/macro';

var RulerItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    left: ", ";\n"], ["\n    left: ", ";\n"])), function (props) { return "".concat(props.left, "%"); });
var templateObject_1;

export { RulerItem };
